// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"uX-z","sponsoredTooltipWrapper":"vX-z","sponsoredTooltip":"wX-z","newCard":"xX-z"};